import { Routes } from '@angular/router';
import { Page403Component } from '@shared-angular/components/page-403/page-403.component';
import { AudionewComponent } from './routes/ai-bot/audionew/audionew.component';
import { BotLoginComponent } from './routes/ai-bot/bot-login/bot-login.component';
import { BotComponent } from './routes/ai-bot/bot/bot.component';
import { DIdAvatarComponent } from './routes/ai-bot/did-avatar/did-avatar.component';
import { LiveAvatarComponent } from './routes/ai-bot/liveavatar/liveavatar.component';
import { MiroComponent } from './routes/auth/miro/miro.component';
import { ReflactTrainComponent } from './routes/auth/reflact-train/reflact-train.component';
import { InstantAccessComponent } from './routes/instant-access/instant-access.component';
import { BotEndComponent } from './shared/components/ai-bot/bot-end/bot-end.component';
import { botaccessGuard } from './shared/guards/botaccess.guard';
import { botprotect } from './shared/guards/botprotect.guard';
import { externalaccessGuard } from './shared/guards/externalaccess.guard';
import { botconfigResolver } from './shared/resolver/botconfig.resolver';
import { botoriginResolver } from './shared/resolver/botorigin.resolver';
import { botprotectResolver } from './shared/resolver/botprotect.resolver';
import { loggedInUserResolver } from './shared/resolver/logged-in-user.resolver';


export const routes: Routes = [
  {
    path: 'botaccess',
    pathMatch: 'full',
    canActivate: [botaccessGuard],
    component: BotEndComponent
  },
  {
    path: 'externalaccess',
    pathMatch: 'full',
    canActivate: [externalaccessGuard],
    component: BotEndComponent
  },
  {
    path: 'botlogin/:id',
    pathMatch: 'full',
    data: { isFullScreenLayout: true },
    component: BotLoginComponent,
    resolve: {
      botOwner: botprotectResolver,
      botConfig: botconfigResolver,
      botOrigin: botoriginResolver
    }
  },
  {
    path: 'botlogin/:id/:origin',
    pathMatch: 'full',
    data: { isFullScreenLayout: true },
    component: BotLoginComponent,
    resolve: {
      botOwner: botprotectResolver,
      botConfig: botconfigResolver,
      botOrigin: botoriginResolver
    }
  },
  {
    path: "bot",
    pathMatch: "full",
    data: { isFullScreenLayout: true },
    component: BotComponent
  },
  {
    path: "bot/:id",
    pathMatch: "full",
    data: { isFullScreenLayout: true },
    component: BotComponent,
    canActivate: [botprotect],
    resolve: { botConfig: botconfigResolver }
  },
  {
    path: "bot/:id/chat",
    pathMatch: "full",
    data: { isFullScreenLayout: true },
    component: BotComponent,
    canActivate: [botprotect],
    resolve: { botConfig: botconfigResolver }
  },
  {
    path: "bot/:id/audio",
    pathMatch: "full",
    data: { isFullScreenLayout: true },
    component: AudionewComponent,
    canActivate: [botprotect],
    resolve: { login: loggedInUserResolver, botConfig: botconfigResolver }
  },
  {
    path: "bot/:id/avatar",
    pathMatch: "full",
    data: { isFullScreenLayout: true },
    component: LiveAvatarComponent,
    canActivate: [botprotect],
    resolve: { login: loggedInUserResolver, botConfig: botconfigResolver }
  },
  {
    path: "bot/:id/did-avatar",
    pathMatch: "full",
    data: { isFullScreenLayout: true },
    component: DIdAvatarComponent,
    canActivate: [botprotect],
    resolve: { login: loggedInUserResolver, botConfig: botconfigResolver }
  },
  {
    path: "bot/:id/end",
    pathMatch: "full",
    data: { isFullScreenLayout: true },
    component: BotEndComponent,
    resolve: { login: loggedInUserResolver, botConfig: botconfigResolver }
  },
  {
    path: 'bot/:id/:bottype/join/:guestid/:metadata',
    pathMatch: 'full',
    component: InstantAccessComponent
  },
  {
    path: 'auth/miro',
    pathMatch: 'full',
    component: MiroComponent
  },
  {
    path: 'auth/reflact-train',
    pathMatch: 'full',
    component: ReflactTrainComponent
  },
  {
    path: '403',
    pathMatch: 'full',
    component: Page403Component
  },
  {
    path: '**',
    redirectTo: '403'
  }
];


